// Text helpers for rendering feed / API values.
//
// Pure and import-free, so Node's type stripping loads it (`pnpm test`).

const NBSP = " ";

// Every space → a non-breaking one (U+00A0), for values the shop prints unbroken (`27&nbsp;Kč`).
export const nbsp = (text: string): string => text.replace(/ /g, NBSP);

// A value as displayed: a literal `&nbsp;` entity (feeds carry them) becomes a real U+00A0, the
// rest is kept, trimmed. Empty or null → null (the element is omitted).
export const displayText = (text: string | null | undefined): string | null => {
  const display = text?.replace(/&nbsp;/gi, NBSP).trim();
  return display ? display : null;
};

// A lookup key for text coming from different sources (feed vs API): `&nbsp;` entities, U+00A0 and
// whitespace runs collapse to one space, the non-breaking hyphen U+2011 becomes `-`, trimmed. Case
// is kept (lowercase the result for a case-insensitive key).
export const normalizeText = (text: string): string =>
  text
    .replace(/&nbsp;/gi, " ")
    .replace(/‑/g, "-")
    .replace(/\s+/g, " ") // `\s` covers U+00A0 too
    .trim();

// `text` cut to `max` characters with `suffix` appended, or unchanged when it fits. Counts code
// points, not UTF-16 units, so a cut never splits a surrogate pair. Does not trim.
export const truncate = (text: string, max: number, suffix = " ..."): string => {
  const chars = Array.from(text);
  return chars.length > max ? `${chars.slice(0, max).join("")}${suffix}` : text;
};

// Class names joined with spaces, falsy entries skipped.
export const joinClasses = (...classes: (string | null | undefined | false)[]): string => classes.filter(Boolean).join(" ");
